export default __webpack_public_path__ + "static/media/plane-seat6.26496a06.svg";